// extracted by mini-css-extract-plugin
module.exports = {"fullPageCenter":"Loading_fullPageCenter__1E2Hv"};